import React from 'react'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { useRedirectURLUpdate } from 'src/hooks/redirect-urls/use-redirect-urls-update.hook'
import { useStyles } from './styes'
import { Formik } from 'formik'
import { UpdateRedirectURLDto } from '../../../../src/types/redirect-url.type'
import { RedirectURLFrom } from './form'
import { useMediaQuery, useTheme } from '@mui/material'

interface IProps {
  modalOpen: boolean
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  id: string
  redirectURL: string
  redirectTarget: string
  note: string | null
}

export const RedirectURLModal = ({
  modalOpen,
  setModalOpen,
  id,
  redirectURL,
  redirectTarget,
  note,
}: IProps) => {
  const { mutate: update } = useRedirectURLUpdate()
  const style = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const handleSubmit = (values: UpdateRedirectURLDto) => {
    update(
      {
        redirect_url: values.redirect_url,
        redirect_target: values.redirect_target,
        id: id,
        note: values.note || null,
      },
      {
        onSuccess: (data) => {
          if (!data) {
            return
          }
          setModalOpen(false)
        },
        onError: () => setModalOpen(false),
      },
    )
    // return setModalOpen(false)
  }
  return (
    <ModalWrapper
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      className={isTablet ? style.ownerInputModalTablet : style.ownerInputModal}
    >
      <Formik
        initialValues={{
          redirect_target: redirectTarget,
          redirect_url: redirectURL,
          note: note || '',
        }}
        onSubmit={handleSubmit}
      >
        <RedirectURLFrom isTablet={isTablet} />
      </Formik>
    </ModalWrapper>
  )
}
